import React, { useMemo } from 'react'
import FilterSelect from '../../../components/Filter/FilterSelect';
import CustomFilterSelect from '../../../components/Filter/CustomFilterSelect';
import DateFilterContainer from '../VisualizationGraph/DateFilterContainer';
import { CITY_KEY_MAP } from '../../../constants';

const Filters = ({ applyFilters, resetFilters, filter, setFilter, appliedFilters, filterData, advancedGraphView }) => {
    const updateFilter = (key, value) => {
        setFilter(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    const isFilterDirty = useMemo(() => {
        return JSON.stringify(filter) !== JSON.stringify(appliedFilters);
    }, [filter, appliedFilters]);



    const filteredJobs = filter.department
        ? filterData.jobs.filter(item => item.department_id === filter.department.value)
        : filterData.jobs;

    const jobOptions = filteredJobs.map(item => ({
        value: item.id,
        label: item.title
    }));

    const jobOptionsWithSpontaneous = [
        { value: 'spontaneous_flag', label: 'Spontaneous Applications' },
        ...jobOptions
    ];

    const currentJobValue = filter.job;

    return (
        <>
            <div className="mb-3 flex flex-wrap items-center gap-5">
                <div className='w-full sm:w-[190px]'>
                    <FilterSelect
                        label_text={"Filter By Department"}
                        options={filterData?.departments?.map(item => ({ value: item.id, label: item.title }))}
                        setState={(val) => { updateFilter("department", val); updateFilter("job", []); }}
                        state={filter.department}
                    />
                </div>
                <div className='w-full sm:w-[250px]'>
                    <CustomFilterSelect
                        isMulti={true}
                        label_text={"Filter By Jobs"}
                        options={(filter.department || advancedGraphView) ? jobOptions : jobOptionsWithSpontaneous}
                        setState={(val) => updateFilter('job', val)}
                        state={currentJobValue}
                        clearable={true}
                        placeholder="All"
                    />
                </div>
                <div className='w-full sm:w-[250px]'>
                    <FilterSelect
                        label_text={"Filter By Location"}
                        options={
                            (advancedGraphView
                                ? filterData.locations.filter(item => CITY_KEY_MAP[item])
                                : filterData.locations
                            ).map(item => ({ value: item, label: item }))
                        }
                        setState={(val) => updateFilter('location', val)}
                        state={filter?.location}
                    />
                </div>
                <div className='flex items-center gap-2 sm:mt-5'>
                    <input
                        type="checkbox"
                        id="removeDuplicates"
                        className='w-4 h-4 accent-primary cursor-pointer'
                        checked={filter.removeDuplicates}
                        onChange={(e) => updateFilter('removeDuplicates', e.target.checked)}
                    />
                    <label htmlFor="removeDuplicates" className='text-sm cursor-pointer select-none'>Remove Duplicates</label>
                </div>
            </div>

            <div className='lg:flex items-center justify-between'>
                <div className="mb-3 lg:mb-0 flex-shrink-0">
                    <DateFilterContainer
                        filter={filter}
                        setFilter={setFilter}
                        updateFilter={updateFilter}
                    />
                </div>

                <div className="flex items-center justify-end space-x-3">
                    {/* Apply */}
                    <div>
                        <button
                            type="button"
                            disabled={!isFilterDirty}
                            onClick={applyFilters}
                            className={`btn-small !w-20 bg-primary text-white`}
                        >
                            Apply
                        </button>
                    </div>

                    {/* Reset */}
                    <div>
                        <button
                            type="button"
                            disabled={!isFilterDirty}
                            onClick={() => {
                                resetFilters();
                            }}
                            className={`btn-small !w-20 bg-secondary text-white`}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Filters